class Observalbe {
    constructor(key) {
        this.key = key;
        this.subscribers = [];
        this.value = "";
    }

    subscribe(callback) {
        this.subscribers.push(callback);
        if (this.value) {
            callback(this.value);
        }
        return () => {
            this.subscribes = this.subscribers.filter(sub => sub !== callback);
        }
    }

    push(value) {
        this.value = value;
        this.subscribers.forEach(callback => callback(value));
    }
};

export const refreshDashboardData = new Observalbe("refreshDashboardData");
export const refreshUserTableData = new Observalbe("refreshUserTableData");
export const refreshCustomerTableData = new Observalbe("refreshCustomerTableData");
export const refreshCountryTableData = new Observalbe("refreshCountryTableData");
export const refreshCurrencyTableData = new Observalbe("refreshCurrencyTableData");
export const refreshCompanyTypeTableData = new Observalbe("refreshCompanyTypeTableData");
export const refreshRecognizedExchangeTableData = new Observalbe("refreshRecognizedExchangeTableData");
export const refreshRegulatoryBodiesTableData = new Observalbe("refreshRegulatoryBodiesTableData");
export const refreshSubscriptionTableData = new Observalbe("refreshSubscriptionTableData");
export const refreshToolTipTableData = new Observalbe("refreshToolTipTableData");